import React, { useRef } from 'react';
import { Box, Typography } from '@mui/material';
import './CategoryBar.css';

function CategoryBar({ groups, currentIndex, setCurrentIndex }) {
  return (
    <Box className="category-sidebar">
      {groups.map((group, idx) => (
        <Typography
          key={idx}
          onClick={() => setCurrentIndex(idx)}
          className={currentIndex === idx ? 'category-selected' : 'category'}
        >
          {group}
        </Typography>
      ))}
    </Box>
  );
}

export default CategoryBar;
